import { type FC } from 'react';
import {
  Note
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconNoteProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconNote: FC<UiIconNoteProps> = (props) => {
  return (
    <UiIcon
      IconComponent={Note}
      {...props}
    />
  );
};
